import { gql } from "apollo-boost"

export const UPDATE_MINISTRATION_PERIOD = gql`
    mutation UpdateMinistrationPeriod(
      $ministrationPeriodData: UpdateMinistrationPeriodInput!,
      $ministrationPeriodId: ID!)
    {
      UpdateMinistrationPeriod(
        ministrationPeriodId: $ministrationPeriodId,
          ministrationPeriodData: $ministrationPeriodData
      ) {
        id
        createdAt
        deletedAt
        modifiedAt
        orderIndex
        revisionDueDate
        revisionStartDate
        revisionEndDate
        ministrationDueDate
        ministrationStartDate
        ministrationEndDate
        ministrationBudget {
          id
          createdAt
          deletedAt
          modifiedAt
          implementer
          alliedOne
          alliedTwo
          ficosec
        }
      }
    }
`